import React, { memo, useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { individualTargetData } from '@model/projectDetails';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import action from '@flux/action';
import { scrollToTopAnimation } from '@utils/common';
import useTheme from '@hooks/useTheme';

const Item = Form.Item;
const { TextArea } = Input;
function TargetCompany(props) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const { saveCreateProjectData, saveData, steps } = props;
  const history = useHistory();
  const [form] = Form.useForm();
  const [scrollToTop] = useState();
  const data = {};

  useEffect(() => {
    scrollToTopAnimation({ y: 360 });
  }, [scrollToTop]);
  saveData.targetCompanyInfo &&
    Object.keys(saveData.targetCompanyInfo).forEach((item) => {
      if (
        item === 'employeeHeadcount' ||
        item === 'estimatedTotalRevenue' ||
        item === 'estimatedMarketCap'
      ) {
        data[`SUBTWO${item}`] = saveData.targetCompanyInfo[item]
          ? `${saveData.targetCompanyInfo[item]}`.replace(
              /(\d)(?=(\d{3})+$)/g,
              '$1,',
            )
          : '';
      } else {
        data[`SUBTWO${item}`] = saveData.targetCompanyInfo[item];
      }
    });
  const renderItem = (item, idx) => {
    if (item.type === 'Input') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={idx + item.name}
          rules={[
            {
              required: item.required,
              whitespace: true,
              pattern: item.pattern,
              message: item.message,
            },
          ]}
        >
          <Input
            maxLength={255}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              if (
                e.target.value &&
                (itemName === 'employeeHeadcount' ||
                  itemName === 'estimatedTotalRevenue' ||
                  itemName === 'estimatedMarketCap')
              ) {
                const num = e.target.value.replace(/,/g, '');
                form.setFieldsValue({
                  [item.name]: num.replace(/(\d)(?=(\d{3})+$)/g, '$1,'),
                });
                form.validateFields([item.name]);
              }
            }}
          />
        </Item>
      );
    }

    if (item.type === 'textArea') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
        >
          <TextArea
            style={{ resize: 'none' }}
            // maxLength={255}
          />
        </Item>
      );
    }

    return (
      <div
        style={{ ...item.style, ...(isLightMode ? { color: '#474747' } : {}) }}
        key={idx + item.name}
      >
        {item.text}
        <span style={{ fontWeight: 700 }}>{item.companyName}</span>
      </div>
    );
  };
  const commonData = (vals) => {
    const data = {
      targetName: null,
      targetCraftId: null,
      targetCompanyInfo: {
        name: vals.SUBTWOname,
        parentCompany: vals.SUBTWOparentCompany || null,
        companyWebsite: vals.SUBTWOcompanyWebsite || null,
        description: vals.SUBTWOdescription,
        industry: vals.SUBTWOindustry,
        headquarters: vals.SUBTWOheadquarters,
        incorporationDate: vals.SUBTWOincorporationDate,
        employeeHeadcount: vals.SUBTWOemployeeHeadcount
          ? Number(vals.SUBTWOemployeeHeadcount.replace(/,/g, ''))
          : null,
        estimatedTotalRevenue: vals.SUBTWOestimatedTotalRevenue
          ? Number(vals.SUBTWOestimatedTotalRevenue.replace(/,/g, ''))
          : null,
        estimatedMarketCap: vals.SUBTWOestimatedMarketCap
          ? Number(vals.SUBTWOestimatedMarketCap.replace(/,/g, ''))
          : null,
      },

      lastNum: 3,
    };
    return data;
  };

  const skipHandler = () => {
    const tempDataForSkip = {
      targetName: null,
      targetCraftId: null,
      targetCompanyInfo: {
        name: null,
        parentCompany: null,
        companyWebsite: null,
        description: null,
        industry: null,
        headquarters: null,
        incorporationDate: null,
        employeeHeadcount: null,
        estimatedTotalRevenue: null,
        estimatedMarketCap: null,
      },

      lastNum: 3,
    };

    saveCreateProjectData({
      ...tempDataForSkip,
      currentStep: 2,
      isEditing: true,
    });
    history.push(`/projects/create/${steps}`);
  };

  const nextHandler = () => {
    form
      .validateFields()
      .then((vals) => {
        saveCreateProjectData({
          ...commonData(vals),
          currentStep: 2,
          isEditing: true,
        });
        history.push(`/projects/create/${steps}`);
      })
      .catch((err) => {
        scrollToTopAnimation({ y: 360 });
      });
  };

  return (
    <Form
      name="createProject"
      form={form}
      initialValues={data}
      layout="vertical"
      autoComplete="off"
    >
      {Array.isArray(individualTargetData) &&
        individualTargetData.map((item, idx) => renderItem(item, idx))}
      <div className="form-actions-wrapper">
        <Button className="ok-btn" onClick={nextHandler}>
          next
        </Button>
        <Button className="skip-btn" onClick={skipHandler}>
          skip
        </Button>

        <Button
          className="previous-btn"
          onClick={() => {
            if (saveData.buyerCheck) {
              saveCreateProjectData({
                ...commonData(form.getFieldsValue()),
                currentNum: 2,
                lastNum: 3,
              });
            } else {
              saveCreateProjectData({
                ...commonData(form.getFieldsValue()),
                currentNum: 1,
                lastNum: 3,
              });
            }
          }}
        >
          previous
        </Button>
      </div>
    </Form>
  );
}

const mapStateToProps = ({ projects }) => ({
  saveData: projects.saveData,
});

const mapDispatchToProps = (dispatch) => ({
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(TargetCompany));
